import React, { useContext, useEffect, useRef, useState } from 'react';
import { FormContext } from '..';
import { setupMaps } from '../../../../modules/map';
// import { setupMaps } from '../../../../modules/map';

const SidebarContact = () => {
  const { cta = {} } = useContext(FormContext);

  const { call, virtual, visit } = cta;

  const mapRef = useRef(null);
  const [setupMap, setSetupMap] = useState(false);

  useEffect(() => {
    if (visit && mapRef?.current && !setupMap) {
      setupMaps(mapRef.current, {
        key: 'AIzaSyCt1YfF8ExNd902cFWca7yTflrxbjaFEAI',
        options: {
          zoom: visit.location.zoom,
          zoomControl: false,
          fullscreenControl: false,
          center: {
            lat: visit.location.lat,
            lng: visit.location.lng,
          },
        },
      });
    }

    setSetupMap(true);
  }, [mapRef]);

  return (
    <div className="c-contact-us__ctas">
      <div className="c-contact-us__cta">
        <h3 className="c-contact-us__cta__title">{call.title}</h3>

        <p className="c-contact-us__cta__text">{call.text}</p>

        <div className="c-contact-us__cta__details">
          <span>{call.status} </span>
          <a
            href={call.phone?.href}
            className="c-contact-us__cta__phone InfinityNumber"
            title="phone"
          >
            <span class="InfinityNumber">{call.phone?.text}</span>
          </a>
        </div>
      </div>

      <div className="c-contact-us__cta">
        <h3 className="c-contact-us__cta__title">{virtual.title}</h3>

        <p className="c-contact-us__cta__text">{virtual.text}</p>
      </div>

      <div className="c-contact-us__cta">
        <h3 className="c-contact-us__cta__title">
          <svg role="presentation" className="c-contact-us__cta__icon">
            <use xlinkHref="/assets/icons/icons.svg#sprite-marker"></use>
          </svg>
          {visit.title}
        </h3>

        <p className="c-contact-us__cta__text">{visit.text}</p>

        <address className="c-contact-us__cta__address">
          {visit.location.address}
        </address>

        <div className="c-contact-us__location__wrap">
          <div
            id="sidebarMap"
            className="c-contact-us__location__map o-map js-map"
            ref={mapRef}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default SidebarContact;
